import { z } from 'zod';
/**
 * Stable object identifiers (UUIDv7, ADR-003). Each identifier is a distinct branded type,
 * so that e.g. a mandate ID cannot accidentally be used as a person ID.
 */
const id = (brand) => z
    .uuid({ version: 'v7', error: `Invalid ${brand}: expected UUIDv7` })
    .brand()
    .meta({ id: brand });
export const TenantId = id('TenantId');
export const PersonId = id('PersonId');
export const LegalEntityId = id('LegalEntityId');
export const ClientId = id('ClientId');
export const MandateId = id('MandateId');
export const EvidenceId = id('EvidenceId');
export const TaskId = id('TaskId');
//# sourceMappingURL=ids.js.map